<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/keywords_example.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("keyw.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Olaf Scholz ist Bundeskanzler der Bundesrepublik Deutschland. Franz Beckenbauer, der Kaiser, hat kein politisches Amt inne. Eine Zeit lang war er der Präsident des FC Bayern München."}
                    </p>

                    <h4 class="font-weight--light">{{ $t("keyw.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"keywords": [["deutschland", 0.4719], ["beckenbauer", 0.3043], ["olaf", 0.3038], ["münchen", 0.2925], ["bayern", 0.208]]}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
